/**
 * Copy text to clipboard with fallback for non-secure contexts (HTTP).
 * navigator.clipboard is only available in secure contexts (HTTPS/localhost).
 * Falls back to execCommand('copy') via a temporary textarea.
 */
export async function copyToClipboard(text: string): Promise<void> {
  if (navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(text);
  }
  // Fallback for HTTP origins (e.g. hookhouse-pro.fmr.local)
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
}
